import { render, staticRenderFns } from "./ChooseShelfDialog.vue?vue&type=template&id=e7bea3f6&scoped=true&"
import script from "./ChooseShelfDialog.vue?vue&type=script&lang=js&"
export * from "./ChooseShelfDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7bea3f6",
  null
  
)

export default component.exports